import { roleGuarded } from '@/components/shell/RoleState';
import { UsersTab } from '@/features/settings/UsersTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/users')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(UsersTab),
});
